import tw from "src/utils/tw";

export default function Notice(props) {
  return (
    <div
      className={tw(
        "text-xs",
        "text-organization",
        "uppercase",
        "bg-paleAction",
        "rounded",
        "inline-block",
        "px-2",
        "py-1",
        "leading-none",
        "border",
        "border-organization",
        props.className
      )}
      // css={{
      //   border: `1px solid ${lighten(0.3, colors.action)}`,
      //   ...props.css,
      // }}
    >
      <i aria-hidden className="far fa-triangle-exclamation" /> {props.children}
    </div>
  );
}
